<section mat-dialog-content class="sign-in">
  <div class="signin-content d-flex">
    <div class="v_image flex-column justify-content-center align-items-center">
      <figure>
        <img
          src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/signin-image.jpg"
          alt="sing up image"
          style="max-width: 15rem; width: 100%"
        />
      </figure>
    </div>
    <div class="d-flex flex-column justify-content-around align-items-center">
      <figure>
        <img
          src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/ic_logo.png"
          alt="sing up image"
          style="width: 100%; height: 4rem; object-fit: contain"
        />
      </figure>
      <p class="text-center">
        OTP has been sent to <br />{{ data.number }}
        <a (click)="closeDialog('change')">edit</a>
      </p>
      <div class="form-group">
        <label for="otp_name" class="form-label">Enter Your OTP</label>
        <ng-otp-input
          #ngOtpInput
          (onInputChange)="onOtpChange($event)"
          [config]="config"
        ></ng-otp-input>
      </div>
      <div class="form-group form-button">
        <button (click)="onSubmit()" class="mt-2 btnGlobal--secondary">
          Verify
        </button>
      </div>
    </div>
  </div>
</section>
